import React from 'react';

function getYouTubeId(url) {
  if (!url) return null;
  var m = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+)/);
  return m ? m[1] : null;
}

function getVimeoId(url) {
  if (!url) return null;
  var m = url.match(/vimeo\.com\/(\d+)/);
  return m ? m[1] : null;
}

export const VideoEmbed = ({ url }) => {
  if (!url) return null;
  var ytId = getYouTubeId(url);
  if (ytId) {
    return (
      <div className="rounded-lg overflow-hidden aspect-video -mx-3 sm:mx-0">
        <iframe src={'https://www.youtube.com/embed/' + ytId} className="w-full h-full" allowFullScreen title="video" />
      </div>
    );
  }
  var vimeoId = getVimeoId(url);
  if (vimeoId) {
    return (
      <div className="rounded-lg overflow-hidden aspect-video -mx-3 sm:mx-0">
        <iframe src={'https://player.vimeo.com/video/' + vimeoId} className="w-full h-full" allowFullScreen title="video" />
      </div>
    );
  }
  return <video src={url} controls className="w-full rounded-lg max-h-96 -mx-3 sm:mx-0" />;
};
